import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class BindingURLService {
  constructor() {}
  public devMode = false;
  public version: "1.0.0";
  public startOftheWeek = "Sunday";
  public rechargeBtn = false;
  public emsUnit = 1; //Mega = 1 , Kilo= 2
  public enableLogging = false;
  public isAzureLogin = false;
  public azureClientID = "";
  public azureTenantID = "";
  public azureRedirectUri = "";

  public jwtUrl = "http://103.58.167.19:91/UNITY_JWTToken";
  public loginUrl = "http://103.58.167.19/LoginNextGen";
  public genericApiUrl = "http://103.58.167.19/NextGenGeneric";
  public alarmLogUrl = "http://103.58.167.19/Alarmlognextgen";
  public siteListingUrl = "http://103.58.167.19/SiteListingAPI";
  public crudApiUrl = "http://103.58.167.19/saveSettingsAPI";
  public reportsApi = "http://103.58.167.19:90/PizNReportsApi";
  public reportsGenerateApi = "http://103.58.167.19:90/PizNReportsApi";
  public cameraImagesUrl = "http://103.58.167.19:90/cameraImages";
  public razorPayURL = "http://103.58.167.19/RazorPayOrder";
  public gridAPI = "http://103.58.167.19/emsGrid/";
  public WfmTTLog = "http://103.58.167.19:8082/AG_WfmTTApi";
  public newMastersUrl = "http://103.58.167.19/NextGenMaster";
  public independentTabUrl = "http://103.58.167.19/Masters_INdependent";

  // ***************************************

  public itocUrl = "/api/Generic/";
  public Wfm_Target_url = "WFMUbuntu/Defaulttemp.aspx";

  public oldgenericApi = "/api/Generic/GenericDashboard1";

  public updatingSiteThreshold = 4;
  public updatingAccessLockThreshold = 1;
  public updatingCameraThreshold = 4;

  public redirecturl3tech = "http://localhost:4202/#/login";

  public CameraAiTargetUrl =
    "https://pizgloria.invendis.com/edotco_uicamera/#/login";
  public AccessLockTargetUrl =
    "https://pizgloria.invendis.com/edotco_uiaccesslock/#/login";
  public EarlyWarningSystemUrl = "http://localhost:59636/#/login";

  public enableEWSLink = true;
  public enableWfm = true;
  public enableAiCameraLink = true;
  public enableAccessLockLink = true;
}
